import React from 'react'
import ReactHtmlParser from 'react-html-parser';

export const JsonTable = (props) => {

    let th = "",
        td = "";
    props.Data.forEach(item => {

        if (item) {
            if (Array.isArray(item)) {
                item.forEach(item => {
                    th += `<th className="text-capitalize">${item.Key}</th>`;
                    td += `<td>${item.Value}</td>`;
                });

            } else {
                Object.keys(item).forEach(key => {
                    th += `<th className="text-capitalize">${key}</th>`;
                    td += `<td>${item[key]}</td>`;
                });
            }
        }

    })

    return (
        <table className="table tp-table table-striped mb-0 tp-table-scroll">
            <tbody>
                <tr>{ReactHtmlParser(th)}</tr>
                <tr>{ReactHtmlParser(td)}</tr>
            </tbody>
        </table>
    )

}

String.prototype.format = function (format) {

    let value = this;

    switch (format.toLowerCase()) {
        case 'c':
        case 'currency':
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            break;
        default:
            break;
    }

    return value
}
Number.prototype.format = function (format) {

    let value = this;

    switch (format.toLowerCase()) {
        case 'c':
        case 'currency':
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            break;
        default:
            break;
    }

    return value
}